export enum Breakpoints {
  XS = 'screen and (max-width: 575px)',
  SM = 'screen and (min-width: 576px) and (max-width: 767px)',
  MD = 'screen and (min-width: 768px) and (max-width: 991px)',
  LG = 'screen and (min-width: 992px) and (max-width: 1199px)',
  XL = 'screen and (min-width: 1200px) and (max-width: 1399px)',
  LT_SM = 'screen and (max-width: 767px)',
  LT_MD = 'screen and (max-width: 991px)',
  LT_LG = 'screen and (max-width: 1199px)',
  LT_XL = 'screen and (max-width: 1399px)',
  GT_XS = 'screen and (min-width: 576px)',
  GT_SM = 'screen and (min-width: 768px)',
  GT_MD = 'screen and (min-width: 992px)',
  GT_LG = 'screen and (min-width: 1200px)',
  GT_XL = 'screen and (min-width: 1400px)',
}
